import AxiosFunction from "../../core/helpers/axios/AxiosFunction";
import AppFunction from "../../core/helpers/app/AppFunction";

export const urlGenerator = (url) =>
  `${AppFunction.getBaseUrl()}/${url
    .split("/")
    .filter((d) => d)
    .join("/")}`;

export const axiosGet = (url, data = null) => {
  return AxiosFunction.axiosGet(urlGenerator(url), data);
};

export const axiosPost = (url, data) => {
  return AxiosFunction.axiosPost({
    url: urlGenerator(url),
    data,
  });
};

export const axiosPatch = (url, data) => {
  return AxiosFunction.axiosPatch({
    url: urlGenerator(url),
    data,
  });
};

export const axiosDelete = (url) => {
  return AxiosFunction.axiosDelete(urlGenerator(url));
};

export const modifyUrl = (pathPart) => {
  try {
    let currentURL = window.location.href;
    const urlObj = new URL(currentURL);
    const pathParts = urlObj.pathname.split("/").filter(Boolean);

    if (pathParts.length > 0) {
      const lastPart = pathParts[pathParts.length - 1];

      const uuidRegex =
        /^[0-9a-f]{8}-[0-9a-f]{4}-[4][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

      if (uuidRegex.test(lastPart) && pathPart!='') {
        pathParts[pathParts.length] = pathPart;
      }else if(!uuidRegex.test(lastPart) && pathPart!=''){
        pathParts[pathParts.length-1] = pathPart;
      } else {
        pathParts.pop();
      }

      urlObj.pathname = pathParts.length > 0 ? `/${pathParts.join("/")}` : "/";

      return urlObj.toString();
    } else {
      return url;
    }
  } catch (error) {
    console.error("Invalid URL:", error);
    return url;
  }
};
